import React, { useEffect, useContext } from "react";
import { DataContext } from "../dataContext";
import useApi from "../api/api";
import { clearSessionToken } from "../api/sessionToken";

const SignOut = () => {
  const api = useApi(false);
  const { setLoggedIn } = useContext(DataContext);

  useEffect(() => {
    const signOut = async () => {
      try {
        // Drop the token BEFORE the request, not after. The backend skips all
        // cookie handling on any request carrying a Bearer header, so sending
        // one here would leave the `np-sending` cookie intact and the user
        // still signed in on the next reload. Without it the request falls back
        // to the cookie, which is exactly what we need the server to clear.
        clearSessionToken();
        await api.delete("session");
        setLoggedIn(false);
      } catch (error) {
        console.error("logout error", error);
      }
    };
    signOut();
  });

  return <h3 className="center_page">You have been logged out</h3>;
};

export default SignOut;
